"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const wpackio_1 = require("@lyfter/wpackio");
new wpackio_1.VueApp([require.context('../php/Blocks', true, /\.vue$/i)]);
const Sticky_1 = require("./functions/Sticky");
const VariationsSwiper_1 = require("./functions/VariationsSwiper");
const VideoPlyr_1 = require("./functions/VideoPlyr");
const Preloader_1 = require("./functions/Preloader");
const CtaPopUp_1 = require("./functions/CtaPopUp");
const MaterialArchive_1 = require("./functions/MaterialArchive");
const SyncWoocommerceForm_1 = require("./functions/SyncWoocommerceForm");
Sticky_1.Sticky.init();
VariationsSwiper_1.VariationsSwiper.initVariationsSwiper();
VideoPlyr_1.VideoPlyr.initPlyr();
Preloader_1.Preloader.initPreloader();
CtaPopUp_1.CtaPopUp.init();
MaterialArchive_1.MaterialArchive.init();
SyncWoocommerceForm_1.SyncWoocommerceForm.init();
